import React from 'react';

import { ErrorCard } from '../../../../../components/ErrorCard';
import { PageHeader } from '../../../../../components/PageHeader';

interface ErrorStateProps {
  message?: string;
  onRetry?: () => void;
}

export const ErrorState: React.FC<ErrorStateProps> = ({ message, onRetry }) => {
  return (
    <div className="p-6 min-h-screen bg-background">
      <PageHeader
        title="Distributor Details"
        description="View and edit distributor information"
      />
      <div className="mt-6">
        <ErrorCard
          title="Error loading distributor"
          message={message || 'Distributor not found'}
          onRetry={onRetry}
        />
      </div>
    </div>
  );
};
